<template>
	<div class="promotion">
        <keep-alive exclude="promotionDetail">
            <router-view />
        </keep-alive>
		<to-top></to-top>
	</div>
</template>

<script>
import toTop from '@/components/to-top'
export default {
    name: 'promotion',
    data() {
        return {}
    },
	components: {
		toTop
	},
    created() {}
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/promotion/index.vue